// GENERATED FILE -- DO NOT COMMIT

type PackageInfo = {
  name: string;
  version: string;
  commit: string;
  commitDate: Date;
  clean: boolean;
  buildDate: Date;
  repo: string;
  author: string;
}

export const PACKAGE_INFO: Readonly<PackageInfo> = {
  name: "vim-monaco",
  version: "1.0.6",
  commit: "cfd0159a0c8caff0e9f940876868d14916bba120",
  commitDate: new Date("2024-11-21T21:23:15-08:00"),
  clean: true,
  buildDate: new Date("2024-11-22T05:23:36.589Z"),
  repo: "https://github.com/pollrobots/vim-monaco.git",
  author: "Paul C Roberts <pacaro@gmail.com>",
};
